import { passiveSupport } from 'passive-events-support/src/utils'
import React, { Component } from 'react'
import { Editor } from '@tinymce/tinymce-react'

/**
 * Rich text editor
 * @author Huong Nguyen
 */

export default class RichTextEditorComponent extends Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit(e) {
    e.preventDefault()
  }
  render() {
    passiveSupport({ debug: false, events: ['touchstart', 'touchmove'] })
    return (
      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        // licenseKey="gpl"
        // onInit={(_evt, editor) => (editorRef.current = editor)}
        // apiKey="towa6o35i0l8bwltwd6a149ogs52kizg018r2qcxmbgdnszg"
        value={this.props.value}
        init={{
          height: this.props.height,
          menubar: false,
          branding: false,
          statusbar: false
        }}
        onEditorChange={this.props.onEditorChange}
        disabled={this.props.disabled}
      />
    )
  }
}
